module.exports = __webpack_public_path__ + "static/media/exitRSM.b3eee5c2.svg";